import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './timeline3.css'

const Timeline3 = (props) => {
  return (
    <div className="thq-section-padding timeline3-container10">
      <div className="timeline3-max-width thq-section-max-width">
        <div className="timeline3-container11">
          <h1 className="timeline3-text10 HeadingOne">
            {props.heading ?? (
              <Fragment>
                <span className="timeline3-text25">
                  Une intégration Simple, Rapide, efficace
                </span>
              </Fragment>
            )}
          </h1>
          <p className="timeline3-text11">
            {props.heading1 ?? (
              <Fragment>
                <span className="timeline3-text24">
                  Bénéficiez d&apos;un accompagnement de bout en bout dans le
                  déploiement de votre solution de télésecrétariat basé sur
                  l&apos;intelligence artificielle.
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <div className="timeline3-timeline-container">
          <div className="timeline3-step1">
            <div className="timeline3-container12">
              <div className="timeline3-progress01"></div>
              <div className="timeline3-container13"></div>
              <div className="timeline3-progress02"></div>
            </div>
            <div className="timeline3-container14">
              <h5 className="timeline3-text12 HeadingThree">
                {props.card1Date ?? (
                  <Fragment>
                    <span className="timeline3-text23">Vos exigences</span>
                  </Fragment>
                )}
              </h5>
              <span className="timeline3-text13 thq-body-small">
                {props.card1Content ?? (
                  <Fragment>
                    <span className="timeline3-text21">
                      Nous organisons un rendez-vous afin de récolter votre
                      besoin, nous vous orientons vers l&apos;offre la plus
                      adaptée.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="timeline3-step2">
            <div className="timeline3-container15">
              <div className="timeline3-progress03"></div>
              <div className="timeline3-container16"></div>
              <div className="timeline3-progress04"></div>
            </div>
            <div className="timeline3-container17">
              <h5 className="timeline3-text14 HeadingThree">
                {props.card1Date3 ?? (
                  <Fragment>
                    <span className="timeline3-text20">Déploiement</span>
                  </Fragment>
                )}
              </h5>
              <span className="timeline3-text15 thq-body-small">
                {props.card2Content ?? (
                  <Fragment>
                    <span className="timeline3-text22">
                      Nous déployons votre agenda et la ligne téléphonique.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="timeline3-step3">
            <div className="timeline3-container18">
              <div className="timeline3-progress05"></div>
              <div className="timeline3-container19"></div>
              <div className="timeline3-progress06"></div>
            </div>
            <div className="timeline3-container20">
              <h5 className="timeline3-text16 HeadingThree">
                {props.card1Date1 ?? (
                  <Fragment>
                    <span className="timeline3-text29">Tests</span>
                  </Fragment>
                )}
              </h5>
              <span className="timeline3-text17 thq-body-small">
                {props.card3Content ?? (
                  <Fragment>
                    <span className="timeline3-text26">
                      Vous bénéficiez d&apos;une phase de test de 2 semaines
                      durant laquelle nous vous permettons d&apos;ajuster les
                      consignes fournies au moteur d&apos;IA.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="timeline3-step4">
            <div className="timeline3-container21">
              <div className="timeline3-progress07"></div>
              <div className="timeline3-container22"></div>
              <div className="timeline3-progress08"></div>
            </div>
            <div className="timeline3-container23">
              <h5 className="timeline3-text18 HeadingThree">
                {props.card1Date2 ?? (
                  <Fragment>
                    <span className="timeline3-text27">Production</span>
                  </Fragment>
                )}
              </h5>
              <span className="timeline3-text19 thq-body-small">
                {props.card5Content ?? (
                  <Fragment>
                    <span className="timeline3-text28">
                      Vos clients profitent d&apos;un experience de prise de
                      rendez-vous inédite.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Timeline3.defaultProps = {
  card1Date3: undefined,
  card1Content: undefined,
  card2Content: undefined,
  card1Date: undefined,
  heading1: undefined,
  heading: undefined,
  card3Content: undefined,
  card1Date2: undefined,
  card5Content: undefined,
  card1Date1: undefined,
}

Timeline3.propTypes = {
  card1Date3: PropTypes.element,
  card1Content: PropTypes.element,
  card2Content: PropTypes.element,
  card1Date: PropTypes.element,
  heading1: PropTypes.element,
  heading: PropTypes.element,
  card3Content: PropTypes.element,
  card1Date2: PropTypes.element,
  card5Content: PropTypes.element,
  card1Date1: PropTypes.element,
}

export default Timeline3
